import React, { Component } from 'react';
import { QuotesSection } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * The quotes section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class QuotesView extends Component {

	render () {
		const {
			heading,
			quotes,
		} = this.props.content.landingPage.quotes;

		return (
			<QuotesSection {...{
				heading,
				quotes,
			}} />
		);
	}
}

export default withLanguageContext(QuotesView);



// WEBPACK FOOTER //
// ./src/components/views/QuotesView/QuotesView.js